module.exports = __webpack_public_path__ + "static/media/weddingServiceAboutCover.31eb6a84.png";